<template>
  <div id="rentalReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title">Rental Listing</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportEnrichReports()">
                <i class="fp-export"></i> Compare
              </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content reservation-report">
            <data-table-filter-config :moduleName="'rentalReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
             <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'rentalReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Rental Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
             </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';


export default {
  name: "RentalReport",
    mixins: [commonMixins, dataTableMixins],
    metaInfo() {
            return {title: "Rental Listing Report | " +process.env.COPYRIGHT_NAME}
        },
    data: () => ({
      cantAccessPage:"",
      permissions:[],
      loading: false,
      rows: [],
      totalRecords: 0,
      userColumns:[],
      action:'list',
      columns: [
                {
                    label: 'Agreement Number',
                    field: 'code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Agreement Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Owner',
                    field: 'ownership',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Owner", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Sts Unit",
                    field: "unit_status",
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Active(A)','In Garage(I)','Sold(S)','Void(V)'], // dropdown (with selected values) instead of text input
                      filterValue: " ", // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Create By User ID',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Create By User ID", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Create By Date',
                    field: 'created_at',
                    fpFieldType:"custom_date",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Create By Time',
                    field: 'created_time',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Create By Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false
                },
                {
                    label: 'Out Date',
                    field: 'actual_out_datetime',
                    fpFieldType:"custom_date",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Out Time',
                    field: 'actual_out_time',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Out Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: "Out Date Backdated?",
                    field: "out_back_dated",
                    hidden:false,
                    fpFieldType:"option",
                    filterable: false,
                    sortable:false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y', 'N'], // dropdown (with selected values) instead of text input
                      filterValue: " ", // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Out Date Difference (Days)',
                    field: 'out_back_diff',
                    fpFieldType:"text",
                    filterable: false,
                    hidden: false,
                    sortable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Out Date Difference (Days)", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Out Reading',
                    field: 'out_read',
                    fpFieldType:"integer",
                    type: 'number',
                    filterable: false,
                    hidden: false,
                    sortable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Out Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'In Date',
                    field: 'actual_in_datetime',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'In Time',
                    field: 'actual_in_time',
                    fpFieldType:"text",
                    hidden: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "In Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false
                },
                {
                    label: "In Date Backdated?",
                    field: "in_back_dated",
                    hidden:false,
                    fpFieldType:"option",
                    filterable: false,
                    sortable:false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y', 'N'], // dropdown (with selected values) instead of text input
                      filterValue: " ", // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'In Date Difference (Days)',
                    field: 'in_back_diff',
                    fpFieldType:"text",
                    filterable: false,
                    hidden: false,
                    sortable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "In Date Difference (Days)", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'User ID Backdated In Date',
                    field: 'created_by_backdated',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User Id Backdated In Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'System Date In Date',
                    field: 'updated_at',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'System Time In Time',
                    field: 'updated_time',
                    fpFieldType:"text",
                    hidden: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "System Date In Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'In Reading',
                    field: 'in_read',
                    fpFieldType:"integer",
                    type: 'number',
                    filterable: false,
                    hidden: false,
                    sortable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "In Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Rental Facility',
                    field: 'pick_up',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Rental Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Rental Facility Description',
                    field: 'pick_up_desc',
                    fpFieldType:"option",
                    filterable: false,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Rental Facility Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Return Facility',
                    field: 'drop_off',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Return Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Return Facility Description',
                    field: 'drop_off_desc',
                    fpFieldType:"option",
                    filterable: false,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Return Facility Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge From Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge From Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge From Facility Description',
                    field: 'location_desc',
                    fpFieldType:"option",
                    filterable: false,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge From Facility Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Exp Return Date',
                    field: 'due_in_datetime',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Sts',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Active","Pending","Expired"]
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Equipment Serial Number',
                    field: 'vin',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Equipment Serial Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Equipment Type',
                    field: 'asset_type',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Equipment Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Type Description',
                    field: 'equip_type_desc',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'GVW',
                    field: 'vehicle_gross_weight',
                    filterable: true,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "GVW", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Term Date',
                    field: 'term_dt',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true
                },
                {
                    label: 'Substitute Unit Number',
                    field: 'sub_unit_no',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Substitute Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Metric Type',
                    field: 'section',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Metric Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                  },
                  sortable:false
                },
                {
                    label: 'User ID Rental Return',
                    field: 'r_updated_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User Id Rental Return", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                  },
                },
                {
                    label: 'Charge From Date',
                    field: 'charge_from_datetime',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge From Time',
                    field: 'charge_from_time',
                    fpFieldType:"text",
                    hidden: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge From Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Charge To Date',
                    field: 'charge_to_datetime',
                    fpFieldType:"custom_date",
                    hidden: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge To Time',
                    field: 'charge_to_time',
                    fpFieldType:"text",
                    hidden: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge To Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: "Different Charge To Date To Actual Return Y N",
                    field: "charge_back_dated",
                    hidden:false,
                    fpFieldType:"option",
                    filterable: false,
                    sortable:false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y', 'N'], // dropdown (with selected values) instead of text input
                      filterValue: " ", // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Days Different Charge to Date to Actual',
                    field: 'charge_back_diff',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    sortable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Days Different Charge to Date to Actual", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Terms Code',
                    field: 'term_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Term Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
      batchProcess:0,
      batchNum:"",

    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'rental_listing_report') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{

        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
          filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }
      $.ajax({
        url: process.env.ROOT_API + "/rental-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            console.log('success');
            if ( self.action == "export" ||  self.action == "export_queue" || self.action == "compare-with-enrich_queue" || self.action == "compare-with-enrich") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" || self.action == "compare-with-enrich" ) {
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
                  self.action = "list";
                  self.loadList();

            } else {
              if (data.content.row != undefined) {

                console.log("data.content.log");
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }



          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'rental-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/RentalListingReport.vue